import React from 'react'
import { Container, Header , Button, Grid} from 'semantic-ui-react'
import insp1 from "../../../../../assets/images/insp1.png"
import insp2 from "../../../../../assets/images/insp2.png"

import "./Section4.css"

const Section4 = () => {
    return <Container className="Section4 p-1">
        {/* <Header className="p-1-t p-1-b" size='huge'>Discover Naroon Experiences</Header> */}
        <Grid columns={1}>
                <Grid.Column className="bg-host">
                    <Header inverted size='huge' className="w-30 font-5 m-3-r m-3-l m-3-t">Questions about hosting?</Header>
                    <Button inverted className="rounded-10  m-3"  size='big'>
                        Ask a Superhost
                    </Button>
                </Grid.Column>
               
                
        </Grid>

     
</Container>
}
 export default Section4